module.exports = __webpack_public_path__ + "img/taylorBellCastingHall201027-239.cb0cc674.jpg";